<template lang="pug">
div
  .panel.mb-4
    v-btn.ml-0(@click='format("h2")', color='primary', outline, small, icon)
      b H2
    v-btn(@click='format("h3")', color='primary', outline, small, icon)
      b H3
    v-btn(@click='format("h4")', color='primary', outline, small, icon)
      b H4
    v-btn(@click='exec("bold")', color='primary', outline, small, icon)
      v-icon(small) format_bold
    v-btn(@click='exec("italic")', color='primary', outline, small, icon)
      v-icon(small) format_italic
    v-btn(@click='exec("underline")', color='primary', outline, small, icon)
      v-icon(small) format_underline
    v-btn(@click='toggleLink', color='primary', outline, small, icon)
      v-icon(small) link
  .wrap-edit
    .xlabel(:class='{ focused: focused || !empty }')
      v-label(:focused='focused') Введите текст
    .editor(
      ref='editor',
      placeholder='Введите текст',
      contenteditable,
      @blur='blur',
      @focus='focus',
      @input='change',
      @change='change',
      @paste='paste'
    )
  v-dialog(v-model='dialog', width='280')
    v-card
      v-form(@submit='close')
        .pa-3
          v-text-field(label='Ссылка', v-model='link', autofocus)
</template>

<script>
import { isEmpty } from 'lodash'
import BaseBlock from './BaseBlock'

export default {
  extends: BaseBlock,

  data: () => ({
    focused: false,
    empty: false,
    dialog: false,
    link: null,
    selected: null,
  }),

  mounted() {
    if (this.block.value !== '') {
      this.$editor.innerHTML = this.block.value
    }

    this.empty = isEmpty(this.getTextValue())
  },

  methods: {
    format(tag) {
      const selection = document.getSelection().anchorNode.parentNode.nodeName
      const ntag = selection === tag.toUpperCase() ? 'div' : tag
      this.exec('formatBlock', false, ntag)
    },

    close(ev) {
      ev.preventDefault()
      this.dialog = false

      restoreSelection(this.selected)

      if (this.link) {
        this.exec('createlink', false, this.link)
      } else {
        this.exec('unlink')
      }

      this.$nextTick(() => (this.link = null))
    },

    toggleLink() {
      const selection = document.getSelection()
      const parent = selection.anchorNode.parentNode

      if (parent.nodeName === 'A') {
        const href = parent.href
        this.link = href
      }

      this.dialog = true
      this.selected = saveSelection()
    },

    blur() {
      this.focused = false
      this.empty = isEmpty(this.getTextValue())
    },

    focus() {
      this.focused = true
    },

    change() {
      this.empty = isEmpty(this.getTextValue())
      this.$emit(
        'update',
        Object.assign(this.block, {
          value: this.getHtmlValue(),
        })
      )
    },

    // prettier-ignore
    paste(event) {
      const paste = (event.clipboardData || window.clipboardData).getData('text')
      const selection = window.getSelection()
      if (selection.rangeCount) {
        selection.deleteFromDocument()
        selection.getRangeAt(0).insertNode(document.createTextNode(paste))
        event.preventDefault()
        this.change()

      }
    },

    exec(command, showUI = false, value = null) {
      document.execCommand(command, showUI, value)
      this.$emit(
        'update',
        Object.assign(this.block, {
          value: this.getHtmlValue(),
        })
      )
    },

    getTextValue() {
      return this.$editor.innerText.trim()
    },

    getHtmlValue() {
      return this.$editor.innerHTML
      // return this.$editor.innerHTML.replace('<br>', '')
    },
  },

  computed: {
    $editor() {
      return this.$refs.editor
    },

    getProp() {
      return { focused: this.focused }
    },
  },
}

const saveSelection = () => {
  if (window.getSelection) {
    const sel = window.getSelection()
    if (sel.getRangeAt && sel.rangeCount) {
      return sel.getRangeAt(0)
    }
  } else if (document.selection && document.selection.createRange) {
    return document.selection.createRange()
  }
  return null
}

const restoreSelection = (range) => {
  if (range) {
    if (window.getSelection) {
      const sel = window.getSelection()
      sel.removeAllRanges()
      sel.addRange(range)
    } else if (document.selection && range.select) {
      range.select()
    }
  }
}
</script>

<style scoped>
.editor {
  font-size: 16px;
  outline: none;
}
[contenteditable='true']:empty:before {
  /*content: attr(placeholder);*/
  /*display: block;*/
  color: rgba(0, 0, 0, 0.54);
  font-size: 16px;
}
.xlabel {
  top: 0;
  left: 0;
  position: absolute;
  pointer-events: none;
  transform-origin: top left;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
.focused {
  transform: translateY(-18px) scale(0.75);
}
.wrap-edit {
  position: relative;
}
</style>
